import { type AxiosResponse } from 'axios';

import { type AddUserPoolType, type FactoryType } from '@/types';
import { camelToSnakeCase } from '@/lib/convert-code-style';

import { axiosPost } from '@/api/AxiosApi';
import { sendRequest } from '@/api/AxiosRequest';
import { type CustomAxiosResponse } from '@/api/AxiosResponse';

export const createFactory = async (aData: FactoryType): Promise<CustomAxiosResponse> => {
  const payload = {
    path: '/staking-factory',
    body: { ...aData },
  };
  return sendRequest(payload, 'createFactory', axiosPost);
};
